const getReduce = (action, state) => {
  return {
    ...state,
    ...{
      [action.key]: {
        ...state[action.key],
        result: action.payload.data,
        pagingInfo: action.payload.pagingInfoByType,
      },
    },
  };
};

// GET /api/v2/ContentSearch response shape: { items: PagedList<Item>, countsByType: [{type,count}] }.
const setSearchList = (action, state) => {
  const { items, countsByType } = action.payload;
  return {
    ...state,
    ...{
      [action.key]: {
        ...state[action.key],
        result: items.items,
        pagingInfo: {
          pageIndex: items.pageIndex,
          pageSize: items.pageSize,
          totalCount: items.totalCount,
          totalPages: items.totalPages,
          hasNextPage: items.hasNextPage,
          hasPreviousPage: items.hasPreviousPage,
        },
        countsByType: countsByType || [],
      },
    },
  };
};

const _default = (action, state) => {
  const newState = { ...state, [action.key]: action.payload };
  return newState;
};

const loadingReduce = (action, state) => {
  const newState = { ...state };
  newState[action.payload.subject]["loading"] = action.payload.active;
  return newState;
};

const setFilter = (action, state) => {
  const newState = { ...state, [action.key]: action.payload };
  return newState;
};

export default (state, action) => {
  let _state = {
    loading: () => loadingReduce(action, state),
    list: () => getReduce(action, state),
    searchList: () => setSearchList(action, state),
    filter: () => setFilter(action, state),
    default: () => _default(action, state),
    step: () => _default(action, state),
  };

  return _state[action.action]();
};
